import { Component, OnChanges, OnInit } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { FinanceProductCardComponent } from './components/finance-product-card/finance-product-card.component';
import { FinanceExploreComponent } from './components/finance-explore/finance-explore.component';
import { FinancingCalculatorService } from './financing-calculator.service';
import { FcBenefitsComponent } from './components/fc-benefits/fc-benefits.component';
import { FcCalcSectionComponent } from './components/fc-calc-section/fc-calc-section.component';

@Component({
    selector: 'app-financing-calculator',
    standalone: true,
    imports: [
        HeaderComponent,
        FooterComponent,
        CommonModule,
        TranslateModule,
        MatIconModule,
        FinanceProductCardComponent,
        FinanceExploreComponent,
        FcBenefitsComponent,
        FcCalcSectionComponent,
    ],
    templateUrl: './financing-calculator.component.html',
})
export class FinancingCalculatorComponent implements OnInit, OnChanges {
    selectedLanguage: any = 'en';
    allProducts: any = [];
    filteredProducts: any = [];
    prodToDisplay: any = [];
    showTimes = 1;
    filter: any = null;

    constructor(private _finService: FinancingCalculatorService) {}
    currentSlide = 0;
    mobileSlides: any[][] = [];

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');

        this._finService.getProducts().subscribe((data: any) => {
            data.map((item: any) => {
                this.allProducts.push(...item.products);
            });
            this.filteredProducts = this.allProducts;
            this.prodToDisplay = this.allProducts.slice(0, 8);
            this.mobileSlides = this.chunkArray(this.filteredProducts, 4);
        });
    }

    ngOnChanges(): void {
        this.mobileSlides = this.chunkArray(this.filteredProducts, 4);
    }

    chunkArray<T>(arr: T[], chunkSize: number): T[][] {
        const chunks: T[][] = [];
        for (let i = 0; i < arr.length; i += chunkSize) {
            chunks.push(arr.slice(i, i + chunkSize));
        }
        return chunks;
    }

    prevSlide() {
        if (this.currentSlide > 0) {
            this.currentSlide--;
        }
    }

    nextSlide() {
        if (this.currentSlide < this.mobileSlides.length - 1) {
            this.currentSlide++;
        }
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    showMoreProducts() {
        this.showTimes++;
        this.prodToDisplay = this.filteredProducts.slice(0, 8 * this.showTimes);
    }

    filterProducts(filter: any) {
        this.filter = filter;
        if (filter.amount === 0) {
            this.filteredProducts = this.allProducts;
            this.prodToDisplay = this.filteredProducts.slice(0, 8);
            return;
        }
        const onlyP2P =
            (filter.provider.includes('alternate-financing') ||
                filter.provider.includes('alternate financing')) &&
            filter.provider.length === 1;
        const notP2P =
            filter.provider.includes('financing') &&
            filter.provider.length === 1;
        const onlyIslamic =
            filter.financingType.includes('islamic') &&
            filter.financingType.length === 1;
        const onlyConventional =
            filter.financingType.includes('conventional') &&
            filter.financingType.length === 1;

        this.filteredProducts = this.allProducts.filter((product: any) => {
            const validation = JSON.parse(product.productValidation);
            if (validation) {
                const isSameDurationUnit =
                    filter.durationUnit === validation?.tenure?.unit;
                const validFAmount =
                    filter.amount >= validation?.financeAmount?.min &&
                    filter.amount <= validation?.financeAmount?.max;

                const validInterestRate =
                    validation?.interestRate?.min <= filter.interestRate &&
                    validation?.interestRate?.max >= filter.interestRate;

                const validTenure =
                    filter.duration >= validation?.tenure?.min &&
                    filter.duration <= validation?.tenure?.max;

                if (
                    isSameDurationUnit &&
                    validFAmount &&
                    validTenure &&
                    validInterestRate
                ) {
                    return product;
                }
            }
        });

        if (onlyIslamic) {
            this.filteredProducts = this.filteredProducts.filter(
                (item: any) => {
                    return item.prodShariah === 'Y';
                }
            );
        }

        if (onlyConventional) {
            this.filteredProducts = this.filteredProducts.filter(
                (item: any) => {
                    return item.prodShariah === 'N';
                }
            );
        }

        if (onlyP2P) {
            this.filteredProducts = this.filteredProducts.filter(
                (item: any) => {
                    return item.productCategory === 'P2P';
                }
            );
        }

        if (notP2P) {
            this.filteredProducts = this.filteredProducts.filter(
                (item: any) => {
                    return item.productCategory !== 'P2P';
                }
            );
        }

        this.showTimes = 1;
        this.prodToDisplay = this.filteredProducts.slice(0, 8);
        this.mobileSlides = this.chunkArray(this.filteredProducts, 4);
    }
}
